"use client"

import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { z } from "zod"
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@/Components/ui/form"
import { Input } from "@/Components/ui/input"

import { User } from "./columns";
import { Checkbox } from "@/Components/ui/checkbox"

const formSchema = z.object({
    forename: z.string(),
    surname: z.string(),
    userName: z.string(),
    displayName: z.string(),
    email: z.string(),
    role: z.boolean(),
})

interface UsersFormProps {
    setUser: (user: User) => void
    user?: User
}

function UsersForm({ setUser, user }: UsersFormProps) {
    // 1. Define your form.
    const form = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        defaultValues: {
            forename: user ? user.forename : "",
            surname: user ? user.surname : "",
            userName: user ? user.userName : "",
            displayName: user ? user.displayName : "",
            email: user ? user.email : "",
            role: user ? user.role === "Admin" : false,
        },
    })

    // 2. Define a submit handler.
    function onSubmit(data: z.infer<typeof formSchema>) {

        setUser({
            id: user ? user.id : "",
            forename: data.forename,
            surname: data.surname,
            userName: data.email,
            displayName: data.displayName,
            email: data.email,
            role: data.role ? "Admin" : "User",
        });

        if (user == null || user == undefined) {
            form.reset();
            setTimeout(() => form.setFocus("forename"), 0);
        }
    }

    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
                <div className="flex flex-row gap-2">
                    <FormField
                        control={form.control}
                        name="forename"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>Forename</FormLabel>
                                <FormControl>
                                    <Input className="w-48" placeholder="Forename" {...field} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                    <FormField
                        control={form.control}
                        name="surname"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>Surname</FormLabel>
                                <FormControl>
                                    <Input className="w-48" placeholder="Surname" {...field} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                </div>
                <div className="flex flex-row gap-2">
                    <FormField
                        control={form.control}
                        name="displayName"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>Display Name</FormLabel>
                                <FormControl>
                                    <Input className="w-48" placeholder="Display Name" {...field} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                    <FormField
                        control={form.control}
                        name="email"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel>Email</FormLabel>
                                <FormControl>
                                    <Input className="w-48" placeholder="Email" {...field} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                </div>
                <div className="flex flex-row gap-2">
                <FormField
                    control={form.control}
                    name="role"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel className="mr-2">Admin</FormLabel>
                            <FormControl>
                                <Checkbox checked={field.value} onCheckedChange={field.onChange} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <button className="ml-auto w-48 button-default" type="submit">Submit</button>
                </div>
            </form>
        </Form>
    )
}

export default UsersForm;
